<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
    <div class="panel-info-box-title">
        @switch (type) {
            @case ('info') {
                <mat-icon>info</mat-icon>
            }
            @case ('warning') {
                <mat-icon>warning</mat-icon>
            }
            @case ('error') {
                <mat-icon>error_outline</mat-icon>
            }
        }
    </div>
    <p><ng-content></ng-content></p>
</div>
